// extracted by mini-css-extract-plugin
module.exports = {"error":"loadable-wrapper-error__3GKWD","success":"loadable-wrapper-success__2Rr8k","hidden":"loadable-wrapper-hidden__CJbQe"};